<ng-container *ngIf="vm$ | async as vm">
  <div class="guts-m-v-1 bulk-edit-bar guts-p-h-0 guts-m-h-1-half">
    <div class="grid grid--align-center">
      <div class="grid__col-6 guts-p-full-0">
        <div>
          <button
            df-button
            df-button-square
            dfButtonType="ghost"
            class="clear-selections-button guts-m-full-1"
            (click)="resetBulkEdit()"
            [attr.aria-label]="vm.bulkUpdateVM.clearSelectionText"
            data-dgat="profileCollection-10e"
          >
            <df-icon icon="cross"></df-icon>
          </button>
          <p class="h3 ib" aria-live="polite">
            {{ vm.bulkUpdateVM.selectedItemsText }}
          </p>
        </div>
      </div>
      <div class="grid__col-6 grid--align-end guts-p-full-1">
        <div>
          <button
            df-button
            dfButtonType="ghost"
            class="guts-m-r-half font-medium"
            (click)="bulkDelete()"
            data-dgat="profileCollection-726"
            [disabled]="!vm.bulkUpdateVM.selectedItems.length"
          >
            <df-icon
              icon="trash"
              class="guts-p-r-3-quart"
              size="medium"
            ></df-icon>
            <span>{{ i18n.UserController_Delete }}</span>
          </button>
          <button
            df-button
            dfButtonType="ghost"
            class="font-medium"
            (click)="bulkUpdate()"
            data-dgat="profileCollection-431"
            [disabled]="!vm.bulkUpdateVM.selectedItems.length"
          >
            <df-icon
              icon="pencil"
              class="guts-p-r-3-quart"
              size="medium"
            ></df-icon>
            <span>{{ i18n.UserController_EditCategories }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
